export const generatedId = () =>
  Math.random().toString(16).slice(-10).toString();
